import _extends from '@babel/runtime/helpers/esm/extends';
import _objectWithoutProperties from '@babel/runtime/helpers/esm/objectWithoutProperties';
import React, { useCallback } from 'react';
import { DrillDownButton, DeleteButton } from './ActionButtons.js';
import ShuttleListItem from './ShuttleListItem.js';
import '@elliemae/ds-classnames';
import '@elliemae/ds-basic/Button';
import '@elliemae/ds-icons/CloseCircle';
import '@elliemae/ds-icons/ArrowShortRight';
import '@elliemae/ds-icons/ArrowShortReturn';
import 'react-spring/web.cjs';
import '@elliemae/ds-basic/TruncatedTooltipText';
import 'react-sortable-hoc';
import '@elliemae/ds-icons/GripperVertical';
import '../../helper.js';
import '@babel/runtime/helpers/esm/defineProperty';
import '@elliemae/ds-utilities/utils';
import 'treetabular';

function ShuttleTargetListItem(_ref) {
  var _ref$item = _ref.item,
      item = _ref$item === void 0 ? {} : _ref$item,
      _ref$onMoveToSource = _ref.onMoveToSource,
      onMoveToSource = _ref$onMoveToSource === void 0 ? function () {
    return null;
  } : _ref$onMoveToSource,
      _ref$onNavigateOnTarg = _ref.onNavigateOnTargetTo,
      onNavigateOnTargetTo = _ref$onNavigateOnTarg === void 0 ? function () {
    return null;
  } : _ref$onNavigateOnTarg,
      _ref$isRoot = _ref.isRoot,
      isRoot = _ref$isRoot === void 0 ? false : _ref$isRoot,
      _ref$showDeleteButton = _ref.showDeleteButton,
      showDeleteButton = _ref$showDeleteButton === void 0 ? true : _ref$showDeleteButton,
      _ref$showDrillDownBut = _ref.showDrillDownButton,
      showDrillDownButton = _ref$showDrillDownBut === void 0 ? true : _ref$showDrillDownBut,
      _ref$showActions = _ref.showActions,
      showActions = _ref$showActions === void 0 ? true : _ref$showActions;
      _ref.index;
      var rest = _objectWithoutProperties(_ref, ["item", "onMoveToSource", "onNavigateOnTargetTo", "isRoot", "showDeleteButton", "showDrillDownButton", "showActions", "index"]);

  var moveToSource = useCallback(function () {
    return onMoveToSource(item);
  }, [item]);
  var navigateOnTargetTo = useCallback(function () {
    return onNavigateOnTargetTo(item);
  }, [item]);
  return /*#__PURE__*/React.createElement(ShuttleListItem, _extends({}, rest, {
    actions: [showDrillDownButton && /*#__PURE__*/React.createElement(DrillDownButton, {
      key: "drill-down",
      disabled: !item.hasChildren && !item.asyncLoad || item.readOnly || item.disableDrillDown,
      onClick: navigateOnTargetTo
    }), showDeleteButton && isRoot && /*#__PURE__*/React.createElement(DeleteButton, {
      key: "delete",
      disabled: item.readOnly,
      onClick: moveToSource,
      "data-testid": "ds-shuttle__close-button"
    })],
    item: item,
    showActions: showActions
  }));
}

export default ShuttleTargetListItem;
//# sourceMappingURL=ShuttleTargetListItem.js.map
